<template>
  <div class="border-t-1px w-full border-[#F4FAFF] my-5"></div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
